import * as React from "react";
import type { SVGProps } from "react";
const SvgCircleFilledExtraSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 12c0 2.204 1.796 4 4 4s4-1.796 4-4-1.796-4-4-4-4 1.796-4 4"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCircleFilledExtraSmall;
